import jsPDF from "jspdf";
import EventBus from "~/libs/eventBus";

("use strict");

const printIcon = `<svg class="icon icon--print" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"></path></svg>`;
const closeIcon = `<svg class="icon icon--close" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>`;

function issueGlobalPrint(paths, origin, page = -1, title = "Dokument", size) {
  // EventBus.dispatch("issuedPrint");
  EventBus.dispatch("issuedPrint");
  EventBus.dispatch("fabricClearSelection");

  let viewerOriginSelector = "";

  if (origin === "main" && page !== -1) {
    viewerOriginSelector = `[data-viewerorigin="${origin}_${page}"]`;
  } else {
    viewerOriginSelector = `[data-viewerorigin="${origin}"]`;
  }

  // const images = paths.map(path => `<img class="page" src="${path}" />`);
  const canvases = [...document.querySelectorAll(viewerOriginSelector)];
  const dataURLs = canvases.map(canvas => canvas.toDataURL("image/png", 1.0));
  EventBus.dispatch("finishedIssuingPrint");
  // const annotations = dataURLs.map(dataURL => `<img class="annotations" src="${dataURL}" />`);
  // const content = images.map((image, index) => {
  //   const annotation = annotations[index] || "";
  //   return `<div class="print-group">${image}${annotation}</div>`;
  // });

  // let printWindowContent = "";

  // printWindowContent += '<div class="toolbar">';
  // printWindowContent += '<div class="btn-group">';
  // printWindowContent += `<button class="btn" onclick="window.print();">${printIcon}Drucken</button>`;
  // printWindowContent += `<button class="btn" onclick="window.close();">${closeIcon}Schließen</button>`;
  // printWindowContent += "</div>";
  // printWindowContent += "</div>";
  // printWindowContent += '<div class="spacer"></div>';
  // printWindowContent += '<div class="print-groups">';
  // printWindowContent += content.join("");
  // printWindowContent += "</div>";

  // const printWindowProxy = window.open("/static/print.html");

  // printWindowProxy.onload = function () {
  //   printWindowProxy.document.body.innerHTML = printWindowContent;
  // };
  const orientation = size?.width > size?.height ? "l" : "p";
  console.log({ orientation });
  // eslint-disable-next-line new-cap
  const pdf = new jsPDF({
    orientation,
    unit: "pt",
    format: "a4",
    putOnlyUsedFonts: true,
    // floatPrecision: 16,
    compress: true
  });
  // add pages if more than 1 should be generated
  if (paths.length > 1) {
    for (let i = 0; i < paths.length - 1; i += 1) {
      pdf.addPage("a4", orientation);
    }
  }
  const width = pdf.internal.pageSize.getWidth();
  const height = pdf.internal.pageSize.getHeight();
  paths.forEach((img, i) => {
    pdf.setPage(i + 1);
    pdf.addImage(img, "JPEG", 0, 0, width, height, `page-${i}`, "FAST", 0);
  });
  dataURLs.forEach((url, i) => {
    pdf.setPage(i + 1);
    pdf.addImage(url, "PNG", 0, 0, width, height, `data-${i}`, "FAST", 0);
  });
  // window.open(URL.createObjectURL(pdf.output("blob")));
  pdf.setProperties({
    title
  });
  const file = new File([pdf.output("blob")], `${title}.pdf`, { type: "application/pdf" });
  window.open(URL.createObjectURL(file));
}

function issueNotesPrint(title, text) {
  const content = text;

  let printWindowContent = "";

  printWindowContent += "<html>";
  printWindowContent += "<head><title>";
  printWindowContent += title;
  printWindowContent += "</title></head>";
  printWindowContent += "<body>";
  printWindowContent += content;
  printWindowContent += "</body>";
  printWindowContent += "</html>";

  const printWindowProxy = window.open("", "PRINT", "height=400,width=600");
  printWindowProxy.document.write(printWindowContent);
  printWindowProxy.document.close();
  printWindowProxy.onafterprint = printWindowProxy.close;
  printWindowProxy.focus();
  printWindowProxy.print();
}

window.issueGlobalPrint = issueGlobalPrint;
window.issueNotesPrint = issueNotesPrint;
